import React, { useEffect, useState } from "react";
import "./LessonNotes.css";

export default function NoteComposer({
  isOpen,
  isDarkMode,
  initialNote = "",
  onSave,
  onCancel,
  onDelete,
}) {
  const [value, setValue] = useState(initialNote);

  useEffect(() => {
    if (isOpen) {
      setValue(initialNote || "");
    }
  }, [isOpen, initialNote]);

  if (!isOpen) return null;

  const hasExistingNote = !!(initialNote && String(initialNote).trim());

  return (
    <>
      <div className="note-composer-overlay" onClick={onCancel} />
      <div className={`note-composer-sheet${isDarkMode ? " dark" : ""}`}>
        <h3>{hasExistingNote ? "Edit note" : "Add a note"}</h3>
        <textarea
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="Write a note for this section..."
          autoFocus
        />
        <div className="note-composer-actions">
          <button type="button" className="note-composer-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="note-composer-save"
            onClick={() => onSave(value)}
          >
            Save
          </button>
          {hasExistingNote && (
            <button type="button" className="note-composer-delete" onClick={onDelete}>
              Delete
            </button>
          )}
        </div>
      </div>
    </>
  );
}
